module.exports = __webpack_public_path__ + "img/walletBox31.34375463.png";